.matwidth{width:fit-content}.mat-div{margin-bottom:10px}
/*# sourceMappingURL=previous-analysis.component-E4RBSZQB.css.map */
